export default __webpack_public_path__ + "static/media/README.dae116b6.md";